import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ce2e7f0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ce2e7f0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce2e7f0')) {
      api.createRecord('5ce2e7f0', component.options)
    } else {
      api.reload('5ce2e7f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ce2e7f0", function () {
      api.rerender('5ce2e7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/paidInfo/index.vue"
export default component.exports